module.exports = __webpack_public_path__ + "assets/logo-short.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-short.jpg
// module id = 286
// module chunks = 7